import { Typography } from "@material-ui/core";
import React from "react";
import { ReservationResultStatusVariant } from "../ReservationResultStatus/ReservationResultStatus";
import useStyles from "./ReservationResultNoticeStyles";

type NoticeVariant = Exclude<ReservationResultStatusVariant, "success">;

interface ReservationResultNoticeProps {
  variant: NoticeVariant;
  title: string;
  description: string;
}

type TitleClassKey = "errorTitle" | "warningTitle";

const titleClassByVariant: Record<NoticeVariant, TitleClassKey> = {
  error: "errorTitle",
  warning: "warningTitle",
};

export const ReservationResultNotice = ({
  variant,
  title,
  description,
}: ReservationResultNoticeProps) => {
  const classes = useStyles();

  return (
    <div className={`${classes.root} ${classes[variant]}`}>
      <Typography className={`${classes.title} ${classes[titleClassByVariant[variant]]}`}>
        {title}
      </Typography>
      <Typography className={classes.description}>{description}</Typography>
    </div>
  );
};
